import { Calendar, Clock, DoorOpen, GraduationCap } from 'lucide-react';
import type { Turno } from '../../types/models';
import { DIAS_OPTIONS } from '../../pages/admin/turnos-shared';

function fmtAudit(iso?: string) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return '—';
  }
}

type Props = {
  turno: Turno;
  totalAulas: number;
  totalIntervalos: number;
};

export function TurnoEditSidePanel({ turno, totalAulas, totalIntervalos }: Props) {
  const turmas = turno._count?.turmas ?? 0;
  const dias = turno.diasFuncionamento ?? [];

  return (
    <div className="ac-modal-dual__side ac-turno-edit-side">
      <div className="ac-modal-dual__side-panel">
        <div className="ac-modal-dual__side-head">
          <Clock size={14} strokeWidth={1.5} />
          <strong>Operação</strong>
        </div>
        <div className="ac-modal-dual__side-body">
          <div
            className={`ac-turno-side-status${turno.ativo ? '' : ' ac-turno-side-status--off'}`}
          >
            <span className="ac-turno-side-status-dot" aria-hidden />
            <div>
              <span className="ac-turno-side-status-val">{turno.ativo ? 'Ativo' : 'Inativo'}</span>
              <span className="ac-turno-side-status-lbl">Status do turno</span>
            </div>
          </div>

          <div className="ac-turno-side-kpis">
            <div className="ac-turno-side-kpi">
              <GraduationCap size={13} />
              <div>
                <span className="ac-turno-side-kpi-val">{turmas}</span>
                <span className="ac-turno-side-kpi-lbl">Turma(s) vinculada(s)</span>
              </div>
            </div>
            <div className="ac-turno-side-kpi">
              <Calendar size={13} />
              <div>
                <span className="ac-turno-side-kpi-val">{totalAulas}</span>
                <span className="ac-turno-side-kpi-lbl">Aulas no template</span>
              </div>
            </div>
            <div className="ac-turno-side-kpi">
              <Clock size={13} />
              <div>
                <span className="ac-turno-side-kpi-val">{turno.toleranciaAtrasoMin ?? 0} min</span>
                <span className="ac-turno-side-kpi-lbl">Tolerância atraso</span>
              </div>
            </div>
          </div>

          <div className="ac-turno-side-meta">
            <div className="ac-turno-side-meta-row">
              <DoorOpen size={12} />
              <div>
                <span className="ac-turno-side-meta-lbl">Portões</span>
                <span className="ac-turno-side-meta-val">
                  {turno.horaAberturaPortoes} – {turno.horaFechamentoPortoes}
                </span>
              </div>
            </div>
          </div>

          <div className="ac-turno-side-dias">
            <span className="ac-turno-side-dias-lbl">Dias ativos</span>
            <div className="ac-turno-side-dias-pills">
              {DIAS_OPTIONS.map((d) => (
                <span
                  key={d.value}
                  className={`ac-turno-side-dia${dias.includes(d.value) ? ' ac-turno-side-dia--on' : ''}`}
                >
                  {d.label}
                </span>
              ))}
            </div>
          </div>

          {turmas > 0 && (
            <p className="ac-turno-side-hint ac-turno-side-hint--info">
              {turmas} turma(s) usam este turno — alterações de horário afetam a grade.
            </p>
          )}

          <p className="ac-turno-side-hint">
            Template: <strong>{totalAulas}</strong> aula(s), <strong>{totalIntervalos}</strong> intervalo(s).
          </p>

          <dl className="ac-turno-side-audit">
            <div>
              <dt>Inclusão</dt>
              <dd>{fmtAudit(turno.criadoEm)}</dd>
            </div>
            <div>
              <dt>Alteração</dt>
              <dd>{fmtAudit(turno.atualizadoEm)}</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}
